<div class="ui grid segment" [ngStyle]="{'height': (this.tournamentsService.Page_Window_Height - 64) + 'px','margin-top': '0px','margin-bottom': '0px','padding-left':'0px','padding-right':'0px'}" style="display:block">


    <div style="background-color:gainsboro;height:50px;width:100%">
        <button style="float:right;width:180px" class="ui big button {{this.tournamentsService.customertransactionButtonControl == 2 ? 'active': ''}} customertransaction_button terminalButton" (click)="TransactionTypeSelected(2)">{{"Transactions" | t}}</button>
        <button style="float:right;width:180px" class="ui big button {{this.tournamentsService.customertransactionButtonControl == 1 ? 'active': ''}} customertransaction_button terminalButton" (click)="TransactionTypeSelected(1)">{{"Bets" | t}}</button>
       <!-- <button style="float:right;width:180px" class="ui big button {{this.tournamentsService.customertransactionButtonControl == 3 ? 'active': ''}} customertransaction_button terminalButton" (click)="TransactionTypeSelected(3)"><i style="float:left" class="money bill alternate icon"></i>{{"PAYOUT" | t}}</button> -->

    </div>
    <div *ngIf="this.tournamentsService.customertransactionButtonControl == 2">
        <div style="background-color:white;height:55px;width:100%;display:flex">
            <div style="margin:5px">
                <button class="ui {{this.allbutton}} circular button" style="height:43px;width:30px" (click)="getAllTransaction()"></button>
                <span>{{"ALL" | t}}</span>
            </div>
            <div style="margin:5px">
                <button class="ui {{this.onlymoneybutton}} circular button" style="height:43px;width:30px" (click)="getOnlyMoneyTransaction()"></button>
                <span> {{"ONLYMONEY" | t}}</span>
            </div>
            <div style="margin:8px">
                <span>{{"TIME" | t}}</span>
                <button style="width:175px;font-size:16px;margin-left:5px;background:#FAA21C" class="ui big button" (click)="OpenDateModal()"><span>{{this.tournamentsService.customerTransactionDate}}</span><span><i style="float:right;" class="caret down icon"></i></span></button>
            </div>
        </div>
        <div [ngStyle]="{'height': (this.tournamentsService.Page_Window_Height - 64-110) + 'px','margin-top': '0px','margin-bottom': '0px','padding-left':'0px','padding-right':'0px'}" style="overflow:auto">
            <table id="CustomerTransaction_Table">
                <tr id="CustomerTransactionTable_1tr">
                    <td style="width:20%">
                        <span>{{"DATE" | t}}</span>
                    </td>

                    <td style="width:10%">
                        <span>{{"SUMMARY" | t}}</span>
                    </td>
                    <td style="width:40%">
                        <span>{{"DEFINITION" | t}}</span>
                    </td>
                    <td style="width:15%">

                        <span>{{"AMOUNT" | t}}</span>
                    </td>
                    <td style="width:15%">
                        <span>{{"BALANCE_CT" | t}} </span>
                    </td>

                </tr>
                <tr *ngFor="let customer of this.tournamentsService.customerTransactionList;let i = index;" class="CustomerTransactionTable_2tr">


                    <td style="width:20%;">
                        <span style="float:left;">{{customer?.TransactionDate}}</span>
                    </td>

                    <td style="width:10%;text-align:center">
                        <button *ngIf="customer?.TransactionTypeId ==4 || customer?.TransactionTypeId ==3||customer?.TransactionTypeId ==8||customer?.TransactionTypeId ==63" class="ui button backgroundcolor" (click)="OpenTransactionDetail(customer.TransactionComment)"><span style="color:white">+</span></button>
                    </td>
                    <td style="width:40%;">
                        <span style="float:left">{{customer?.TransactionType}}</span>
                    </td>
                    <td style="width:15%;">

                        <span style="float:right;">{{customer?.Amount}}</span>
                    </td>
                    <td style="width:15%;">
                        <span style="float:right;">{{customer?.TransactionBalance}}</span>
                    </td>

                </tr>
            </table>






        </div>

    </div>
    <div *ngIf="this.tournamentsService.customertransactionButtonControl== 1">
        <div style="background-color:white;height:55px;width:100%;display:flex">

            <div style="margin:8px">
                <span>{{"TIME" | t}}</span>
                <button style="width:175px;font-size:16px;margin-left:5px;background:#FAA21C" class="ui big button" (click)="OpenBetsDateModal()"><span>{{this.customerBetsDate}}</span><span><i style="float:right;" class="caret down icon"></i></span></button>
            </div>
            <div style="margin:8px">
                <span>{{"STATUS" | t}}</span>
                <button style="width:175px;font-size:16px;margin-left:5px;background:#FAA21C" class="ui big button" (click)="OpenBetsStateModal()"><span>{{this.customerBetsStatus}}</span><span><i style="float:right;" class="caret down icon"></i></span></button>
            </div>
        </div>
        <div [ngStyle]="{'height': (this.tournamentsService.Page_Window_Height - 64-110) + 'px','margin-top': '0px','margin-bottom': '0px','padding-left':'0px','padding-right':'0px'}" style="overflow:auto">
            <table id="CustomerBets_Table">
                <tr id="CustomerBetsTable_1tr">
                    <td style="width:12%">
                        <span>{{"DATE" | t}}</span>
                    </td>

                    <td style="width:10%">
                        <span>{{"SUMMARY" | t}}</span>
                    </td>
                    <td style="width:28%">
                        <span>{{"TYPE" | t}}</span>
                    </td>
                    <td style="width:10%">

                        <span>{{"STATUS" | t}}</span>
                    </td>
                    <td style="width:10%">
                      <span>{{"TotalOddValue_2" | t}} </span>
                    </td>
                    <td style="width:10%">

                        <span>{{"AMOUNT" | t}}</span>
                    </td>
                    <td style="width:10%">
                        <span>{{"MAXGAIN" | t}} </span>
                    </td>
                    <td style="width:10%">
                        <span>{{"GAIN" | t}} </span>
                    </td>
                </tr>
                <tr *ngFor="let customer of this.tournamentsService.CustomerBetsList;let i = index;" class="CustomerBetsTable_2tr">


                    <td style="width:12%;">
                        <span style="float:left;">{{customer?.CreateDate}}</span>
                    </td>

                    <td style="width:10%;text-align:center">
                        <button style="width:90%;border-radius:15px" class="ui button backgroundcolor" (click)="GetBetsDetail(customer.SlipId)"><span style="color:white;text-transform:lowercase">{{"SUMMARY" | t}}</span></button>
                    </td>
                    <td style="width:28%;">
                        <span style="float:left" >{{customer?.SlipType}}</span>
                    </td>
                    <td style="width:10%;text-align:center">

                        <div style="width:90%;margin-left:5%" [style.backgroundColor]="customer?.StateColor" ><span>{{this._translate.getT(customer?.SlipState)}}</span></div>
                    </td>
                    <td style="width:10%;text-align:center">
                        <span>{{customer?.TotalOddValue}}</span>
                    </td>
                    <td style="width:10%;text-align:center">
                        <span>{{customer?.Amount}}</span>
                    </td>
                    <td style="width:10%;text-align:center">
                        <span>{{customer?.PossibleGain}}</span>
                    </td>
                    <td style="width:10%;text-align:center">
                        <span>{{customer?.Gain}}</span>
                    </td>
                </tr>
            </table>






        </div>

    </div>
</div>
<div class="ui modal" id="customertransactiondate" style="position:absolute;left:40%;bottom:35%; width:450px !important">
    <div class="ui card " id="customertransactiondate_ui card" style="width:450px">
        <div class="content" style="height:60px;padding-right: 0px">

            <button class="circular ui icon button" style="float:right;background-color: white;border: 1px solid;" (click)="ExitDateModal()">
                <i class="remove link icon"></i>
            </button>
        </div>

        <div class="content" id="customertransactiondate" style="height:400px">
            <div>
                <table id="customertransactiondate_table" style="width:100%;color:white;text-align:center">
                    <tr class="customertransactiondate_tr" (click)="SelectDate(0)">
                        <td style="background-color:#111111;cursor:context-menu">


                            <span>{{"Today" | t}}</span>

                        </td>

                    </tr>
                    <tr class="customertransactiondate_tr" (click)="SelectDate(3)">
                        <td style="background-color:#333333;cursor:context-menu">


                            <span>3</span><span> {{"Day" | t}}</span>

                        </td>
                    </tr>
                    <tr class="customertransactiondate_tr" (click)="SelectDate(7)">
                        <td style="background-color:#111111;cursor:context-menu">


                            <span>7</span><span> {{"Day" | t}}</span>

                        </td>
                    </tr>
                    <tr class="customertransactiondate_tr" (click)="SelectDate(30)">
                        <td style="background-color:#333333;cursor:context-menu">

                            <span>30</span><span> {{"Day" | t}}</span>

                        </td>
                    </tr>
                    <tr class="customertransactiondate_tr" (click)="SelectDate(90)">
                        <td style="background-color:#111111;cursor:context-menu">


                            <span>90</span><span> {{"Day" | t}}</span>

                        </td>
                    </tr>

                </table>


            </div>

        </div>



    </div>

</div>
<div class="ui modal" id="customerbetsdate" style="position:absolute;left:40%;bottom:35%; width:450px !important">
    <div class="ui card " id="customerbetsdate card" style="width:450px">
        <div class="content" style="height:60px;padding-right: 0px">

            <button class="circular ui icon button" style="float:right;background-color: white;border: 1px solid;" (click)="ExitBetsDateModal()">
                <i class="remove link icon"></i>
            </button>
        </div>

        <div class="content" id="customerbetsdatediv" style="height:400px">
            <div>
                <table id="customerbetsdate_table" style="width:100%;color:white;text-align:center">
                    <tr class="customerbetsdate_tr" (click)="SelectBetsDate(0)">
                        <td style="background-color:#111111;cursor:context-menu">


                            <span>{{"Today" | t}}</span>

                        </td>

                    </tr>
                    <tr class="customerbetsdate_tr" (click)="SelectBetsDate(3)">
                        <td style="background-color:#333333;cursor:context-menu">


                            <span>3</span><span> {{"Day" | t}}</span>

                        </td>
                    </tr>
                    <tr class="customerbetsdate_tr" (click)="SelectBetsDate(7)">
                        <td style="background-color:#111111;cursor:context-menu">


                            <span>7</span><span> {{"Day" | t}}</span>

                        </td>
                    </tr>
                    <tr class="customerbetsdate_tr" (click)="SelectBetsDate(30)">
                        <td style="background-color:#333333;cursor:context-menu">

                            <span>30</span><span> {{"Day" | t}}</span>

                        </td>
                    </tr>
                    <tr class="customerbetsdate_tr" (click)="SelectBetsDate(90)">
                        <td style="background-color:#111111;cursor:context-menu">


                            <span>90</span><span> {{"Day" | t}}</span>

                        </td>
                    </tr>

                </table>


            </div>

        </div>



    </div>

</div>
<div class="ui modal" id="customerbetsstate" style="position:absolute;left:40%;bottom:35%; width:450px !important">
    <div class="ui card " id="customerbetsstate_card" style="width:450px">
        <div class="content" style="height:60px;padding-right: 0px">

            <button class="circular ui icon button" style="float:right;background-color: white;border: 1px solid;" (click)="ExitBetsStateModal()">
                <i class="remove link icon"></i>
            </button>
        </div>
        <div class="content" id="customerbetsstatediv" style="height:430px">
            <div>
                <table id="customerbetsstate_table" style="width:100%;color:white;text-align:center">
                    <tr class="customerbetsstate_tr" (click)="SelectBetsState('All')">
                        <td style="background-color:#111111;cursor:context-menu">


                            <span>{{"All" | t}}</span>

                        </td>

                    </tr>
                    <tr class="customerbetsstate_tr" (click)="SelectBetsState('Open')">
                        <td style="background-color:#333333;cursor:context-menu">


                          <span> {{"Open" | t}}</span>

                        </td>
                    </tr>
                    <tr class="customerbetsstate_tr" (click)="SelectBetsState('Lost')">
                        <td style="background-color:#111111;cursor:context-menu">


                            <span> {{"Lost" | t}}</span>

                        </td>
                    </tr>
                    <tr class="customerbetsstate_tr" (click)="SelectBetsState('Won')">
                        <td style="background-color:#333333;cursor:context-menu">

                         <span> {{"Won" | t}}</span>

                        </td>
                    </tr>
                    <tr class="customerbetsstate_tr" (click)="SelectBetsState('Cashout')">
                        <td style="background-color:#111111;cursor:context-menu">


                            <span> {{"Cashout" | t}}</span>

                        </td>
                    </tr>
                    <tr class="customerbetsstate_tr" (click)="SelectBetsState('Cancel')">
                        <td style="background-color:#111111;cursor:context-menu">


                            <span> {{"Cancel" | t}}</span>

                        </td>
                    </tr>

                </table>


            </div>

        </div>



    </div>
    </div>
<div class="ui modal " id="Customer_Keyboard_Modal" style="position:absolute;left:25%;bottom:25%; width:1000px !important">
    <div class="ui fluid icon action input" style="margin:10px">
        <input placeholder="Password" type="password" id="CustomerKeyboard_Input" style="text-align:left" value="{{this.tournamentsService.customerPayoutPassword}}" />
        <button class="ui icon button" (click)="CustomerKeyboard_InputClear()">
            <i class="times circle outline large icon"></i>
        </button>

    </div>
    <div class="inline field" style="text-align: center;color:red;">


        <span *ngIf="this.tournamentsService.customerPasswordMessageVisible==1">{{this.tournamentsService.CustomerPasswordMessage}}</span>

    </div>

    <div class="ui grid" style="margin:10px">

        <div style="padding:0">

            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="CustomerKeyboard_ChangeValue(1)">
                1
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="CustomerKeyboard_ChangeValue(2)">
                2
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="CustomerKeyboard_ChangeValue(3)">
                3
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="CustomerKeyboard_ChangeValue(4)">
                4
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="CustomerKeyboard_ChangeValue(5)">
                5
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="CustomerKeyboard_ChangeValue(6)">
                6
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="CustomerKeyboard_ChangeValue(7)">
                7
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="CustomerKeyboard_ChangeValue(8)">
                8
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="CustomerKeyboard_ChangeValue(9)">
                9
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="CustomerKeyboard_ChangeValue(0)">
                0
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="CustomerKeyboard_ChangeValue('-')">
                -
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="CustomerKeyboard_ChangeValue('_')">
                _
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="CustomerKeyboard_ChangeValue('!')">
                !
            </button>


        </div>

        <div style="padding:0;padding-left:30px">
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="CustomerKeyboard_ChangeValue('q')">
                q
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="CustomerKeyboard_ChangeValue('w')">
                w
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="CustomerKeyboard_ChangeValue('e')">
                e
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="CustomerKeyboard_ChangeValue('r')">
                r
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="CustomerKeyboard_ChangeValue('t')">
                t
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="CustomerKeyboard_ChangeValue('z')">
                z
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="CustomerKeyboard_ChangeValue('u')">
                u
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="CustomerKeyboard_ChangeValue('i')">
                i
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="CustomerKeyboard_ChangeValue('o')">
                o
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="CustomerKeyboard_ChangeValue('p')">
                p
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="CustomerKeyboard_ChangeValue('ü')">
                ü
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="CustomerKeyboard_ChangeValue('?')">
                ?
            </button>
        </div>


        <div style="padding:0;padding-left:60px">
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="CustomerKeyboard_ChangeValue('a')">
                a
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="CustomerKeyboard_ChangeValue('s')">
                s
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="CustomerKeyboard_ChangeValue('d')">
                d
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="CustomerKeyboard_ChangeValue('f')">
                f
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="CustomerKeyboard_ChangeValue('g')">
                g
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="CustomerKeyboard_ChangeValue('h')">
                h
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="CustomerKeyboard_ChangeValue('j')">
                j
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="CustomerKeyboard_ChangeValue('k')">
                k
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="CustomerKeyboard_ChangeValue('l')">
                l
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="CustomerKeyboard_ChangeValue('ö')">
                ö
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="CustomerKeyboard_ChangeValue('ä')">
                ä
            </button>
        </div>

        <div style="padding:0;padding-left:90px">
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="CustomerKeyboard_ChangeValue('y')">
                y
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="CustomerKeyboard_ChangeValue('x')">
                x
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="CustomerKeyboard_ChangeValue('c')">
                c
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="CustomerKeyboard_ChangeValue('v')">
                v
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="CustomerKeyboard_ChangeValue('b')">
                b
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="CustomerKeyboard_ChangeValue('n')">
                n
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="CustomerKeyboard_ChangeValue('m')">
                m
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="CustomerKeyboard_ChangeValue(',')">
                ,
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="CustomerKeyboard_ChangeValue('.')">
                .
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="CustomerKeyboard_ChangeValue('')">
                '
            </button>
        </div>

        <div style="padding:0;padding-left:140px">

            <button class="circular ui icon button" style="margin:5px;height:44px;width:370px;float:left; border: 2px solid #BDBDBD;background: linear-gradient(to top, #C7C7C7, #FBFBFB);" (click)="CustomerKeyboard_ChangeValue(' ')"></button>
            <button class="circular ui icon button" style="margin:5px;height:44px;width:95px; border: 2px solid #BDBDBD;background: linear-gradient(to top, #C7C7C7, #FBFBFB);" (click)="CustomerKeyboard_Backspace()">
                <i class="arrow left icon"></i>
            </button>
            <button class="ui big green button" (click)="CustomerPasswordControl()"><span>{{"OK" | t}}</span></button>


            <button class="ui big red button"  (click)="CustomerKeyboard_Close()">
                <span>{{"Close" | t}}</span>
            </button>
        </div>
    </div>
</div>

<style>
    ::-webkit-scrollbar {
        width: 3px;
    }

    ::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
        background-color: #F5F5F5;
    }

    ::-webkit-scrollbar-thumb {
        background-color: #000000;
    }
</style>
